import { PORTFOLIO_TOGGLE_CONFIG } from '@/constants/portfolio-toggle.constants';

export class PortfolioToggleService {
  static getPortfolioConfig(portfolioType) {
    return PORTFOLIO_TOGGLE_CONFIG.PORTFOLIOS[portfolioType];
  }

  static getDefaultPortfolio() {
    return PORTFOLIO_TOGGLE_CONFIG.DEFAULT_PORTFOLIO;
  }

  static getSolutionsLayerId() {
    return PORTFOLIO_TOGGLE_CONFIG.SOLUTIONS_LAYER_ID;
  }

  static isPortfolioActive(activePortfolio, portfolioType) {
    if (!activePortfolio?.name) return false;
    
    const config = this.getPortfolioConfig(portfolioType);
    return activePortfolio.name.toLowerCase() === config.name.toLowerCase();
  }

  static createRouteParams(currentRoute, layerId) {
    return {
      name: 'LayerScreen',
      params: {
        category: currentRoute.params.category,
        sector: currentRoute.params.sector,
        layer: layerId,
      },
    };
  }

  static validatePortfolioType(portfolioType) {
    return Object.prototype.hasOwnProperty.call(PORTFOLIO_TOGGLE_CONFIG.PORTFOLIOS, portfolioType);
  }
}